if($(".hero-intro").length) {

    let scrollIndicator = $(".hero-intro .scroll-arrow-indicator");

    if(scrollIndicator.length) {

        setInterval(function() {
            scrollIndicator.toggleClass('bounce');
        }, 1200);

    }

    scrollIndicator.click('click', function(e) {

        e.preventDefault();

        let parentSection = $(this).closest('.hero-intro'),
            nextSection = parentSection.next('section');

        $('html, body').animate({
            scrollTop: nextSection.offset().top
        }, 300);

    });

}
